(() => {
  const money = new Intl.NumberFormat('en-PK', {
    style: 'currency', currency: 'PKR', maximumFractionDigits: 0,
  });

  function showSkeleton(grid) {
    grid.replaceChildren();
    for (let index = 0; index < 4; index += 1) {
      const item = document.createElement('div');
      item.className = 'avocado-recommendations__skeleton';
      item.setAttribute('aria-hidden', 'true');
      item.innerHTML = '<span></span><i></i><b></b>';
      grid.append(item);
    }
  }

  function card(product, showPrice) {
    const link = document.createElement('a');
    link.className = 'avocado-recommendations__card';
    link.href = product.onlineStoreUrl;

    const media = document.createElement('div');
    media.className = 'avocado-recommendations__media';
    if (product.imageUrl) {
      const image = document.createElement('img');
      image.src = product.imageUrl;
      image.alt = product.title;
      image.loading = 'lazy';
      image.decoding = 'async';
      media.append(image);
    }

    const title = document.createElement('div');
    title.className = 'avocado-recommendations__title';
    title.textContent = product.title;
    link.append(media, title);
    if (showPrice) {
      const price = document.createElement('div');
      price.className = 'avocado-recommendations__price';
      price.textContent = money.format(Number(product.price));
      link.append(price);
    }
    return link;
  }

  function init(root) {
    const grid = root.querySelector('.avocado-recommendations__grid');
    const more = root.querySelector('.avocado-recommendations__more');
    const status = root.querySelector('.avocado-recommendations__status');
    const sentinel = root.querySelector('.avocado-recommendations__sentinel');
    const variants = JSON.parse(root.querySelector('.avocado-recommendations__variants')?.textContent || '{}');
    const limit = Math.min(12, Math.max(4, Number(root.dataset.initialCount) || 12));
    const maximum = Math.min(60, Math.max(limit, Number(root.dataset.maxProducts) || 60));
    const showPrice = root.dataset.showPrice !== 'false';
    const seen = new Set();
    let page = 1;
    let loading = false;
    let finished = false;
    let controller;

    function resetForSize(size) {
      if (!size || size === root.dataset.size) return;
      controller?.abort();
      loading = false;
      root.dataset.size = size;
      grid.replaceChildren();
      seen.clear();
      page = 1;
      finished = false;
      grid.setAttribute('aria-busy', 'true');
      load();
    }

    function readVariant(variant) {
      const id = String(variant?.id || new URLSearchParams(location.search).get('variant') || '');
      resetForSize(variants[id]);
    }

    async function load() {
      if (loading || finished || seen.size >= maximum) return;
      loading = true;
      const currentController = new AbortController();
      controller = currentController;
      more.disabled = true;
      status.textContent = page === 1 ? 'Loading matching styles' : 'Loading more matching styles';
      if (page === 1 && seen.size === 0) showSkeleton(grid);
      const params = new URLSearchParams({
        surface: 'product_page', product_id: root.dataset.productId,
        page: String(page), limit: String(limit),
      });
      if (root.dataset.size) params.set('size', root.dataset.size);
      try {
        const response = await fetch(`${root.dataset.endpoint}?${params}`, {
          credentials: 'same-origin', headers: { Accept: 'application/json' },
          signal: currentController.signal,
        });
        if (!response.ok) throw new Error('recommendations_unavailable');
        const body = await response.json();
        const remaining = Math.max(0, maximum - seen.size);
        const products = body.products.filter((product) => !seen.has(product.id)).slice(0, remaining);
        if (page === 1) grid.replaceChildren();
        products.forEach((product) => {
          seen.add(product.id);
          grid.append(card(product, showPrice));
        });
        page += 1;
        finished = !body.pagination.hasMore || seen.size >= maximum || products.length === 0;
        status.textContent = seen.size ? 'Matching styles loaded' : '';
        root.hidden = seen.size === 0;
      } catch (error) {
        if (error.name === 'AbortError') return;
        if (seen.size === 0) root.hidden = true;
        finished = true;
      } finally {
        if (controller !== currentController) return;
        loading = false;
        grid.setAttribute('aria-busy', 'false');
        more.disabled = false;
        more.hidden = finished;
      }
    }

    more.addEventListener('click', load);
    document.addEventListener('variant:change', (event) => readVariant(event.detail?.variant));
    document.addEventListener('change', () => setTimeout(() => readVariant(), 0));
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting) && page > 1) load();
        if (finished) observer.disconnect();
      }, { rootMargin: '500px 0px' });
      observer.observe(sentinel);
    }
    load();
  }

  document.querySelectorAll('[data-avocado-recommendations]').forEach(init);
})();
